import { Component, ChangeDetectionStrategy } from '@angular/core';

import { Disclaimer } from 'src/config/constants'

@Component({
    selector: 'app-fund-received',
    templateUrl: './funds-received.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FundsReceivedComponent {
  disclaimerText = Disclaimer;
}
